<template>
  <div class="admin-page">
    <div class="admin-toolbar">
      <div class="admin-toolbar__actions">
        <el-input v-model="filters.referrerUserId" placeholder="推荐人ID" clearable class="filter-input" />
        <el-input v-model="filters.refereeUserId" placeholder="被推荐人ID" clearable class="filter-input" />
        <el-button type="primary" @click="fetchBindings">查询绑定</el-button>
        <el-button @click="fetchCommission">分润流水</el-button>
      </div>
    </div>

    <el-tabs v-model="activeTab">
      <el-tab-pane label="绑定记录" name="bindings">
        <el-table :data="bindings" v-loading="loadingBindings">
          <el-table-column prop="id" label="ID" width="70" />
          <el-table-column prop="couponNo" label="券号" width="130" />
          <el-table-column prop="couponType" label="类型" width="90" />
          <el-table-column label="推荐人" min-width="120">
            <template #default="s">{{ s.row.referrerNickname }} ({{ s.row.referrerUserId }})</template>
          </el-table-column>
          <el-table-column label="被推荐人" min-width="120">
            <template #default="s">{{ s.row.refereeNickname || s.row.refereeUsername }} ({{ s.row.refereeUserId }})</template>
          </el-table-column>
          <el-table-column prop="bonusPaid" label="已赠金" width="80" />
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="合伙人分润" name="commission">
        <el-table :data="commissions" v-loading="loadingCommission">
          <el-table-column prop="orderNo" label="订单号" min-width="160" show-overflow-tooltip />
          <el-table-column prop="partnerUserId" label="合伙人" width="90" />
          <el-table-column prop="orderAmountCents" label="订单(分)" width="100" />
          <el-table-column prop="commissionCents" label="分润(分)" width="100" />
          <el-table-column prop="status" label="状态" width="90" />
        </el-table>
      </el-tab-pane>
    </el-tabs>

    <div class="partner-grant">
      <h4>开通合伙人</h4>
      <el-input v-model="partnerUserId" placeholder="用户 ID" style="width: 160px; margin-right: 8px" />
      <el-button type="warning" @click="grantPartner(true)">开通</el-button>
      <el-button @click="grantPartner(false)">关闭</el-button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ReferralBindingsManagement',
  data() {
    return {
      activeTab: 'bindings',
      loadingBindings: false,
      loadingCommission: false,
      bindings: [],
      commissions: [],
      filters: { referrerUserId: '', refereeUserId: '' },
      partnerUserId: ''
    }
  },
  created() {
    this.fetchBindings()
  },
  methods: {
    async fetchBindings() {
      this.loadingBindings = true
      try {
        const res = await axios.post('/api/v1/admin/referral/bindings/list', {
          page: 1,
          pageSize: 50,
          referrerUserId: Number(this.filters.referrerUserId) || undefined,
          refereeUserId: Number(this.filters.refereeUserId) || undefined
        })
        if (res.data.code === 200) {
          this.bindings = res.data.data?.bindings || []
        }
      } finally {
        this.loadingBindings = false
      }
    },
    async fetchCommission() {
      this.activeTab = 'commission'
      this.loadingCommission = true
      try {
        const res = await axios.post('/api/v1/admin/referral/commission/list', {
          page: 1,
          pageSize: 50,
          partnerUserId: Number(this.filters.referrerUserId) || undefined
        })
        if (res.data.code === 200) {
          this.commissions = res.data.data?.items || []
        }
      } finally {
        this.loadingCommission = false
      }
    },
    async grantPartner(isPartner) {
      const uid = Number(this.partnerUserId)
      if (!uid) {
        this.$message.warning('请输入用户 ID')
        return
      }
      const res = await axios.post('/api/v1/admin/partner/grant', { userId: uid, isPartner })
      if (res.data.code === 200) {
        this.$message.success(res.data.message)
      } else {
        this.$message.error(res.data.message || '操作失败')
      }
    }
  }
}
</script>

<style scoped>
.partner-grant { margin-top: 24px; padding-top: 16px; border-top: 1px solid #eee; }
</style>
